import React from "react";
import PropTypes from "prop-types";
import GenericCard from "../UI/GenericCard/GenericCard";

const WinningMonthsCard = (props) => {
  const { backtestResults } = props;

  return (
    <GenericCard title="Winning months">
      <h2>{backtestResults.metrics.winningMonths}</h2>
      <h5>out of {backtestResults.metrics.totalMonths} months with trades</h5>
      <div className="flex pt-2 gap-3">
        <div>
          <h5>Success rate</h5>
          <h3>{backtestResults.metrics.monthlySuccessRate}%</h3>
        </div>
        <div>
          <h5>Win-Loss Ratio</h5>
          <h3>{backtestResults.metrics.winLossRatio}</h3>
        </div>
      </div>
    </GenericCard>
  );
};
WinningMonthsCard.propTypes = {
  backtestResults: PropTypes.object,
};

export default WinningMonthsCard;
